import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Snackbars from "components/Snackbar/Snackbar.js";
import { downloadReport } from "./downloadRequest";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { useSearch } from "hooks/useSearch";
import { dateValidator } from "helpers/dateValidator";
import { unitTypeSelect } from "./unitTypeSelect";
import { GlobalBox } from "components/Box/GlobalBox";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { animations } from "helpers/animations";
import CloseIcon from "@material-ui/icons/Close";
import { useForm } from "hooks/useForm";
import { fieldValidations, initialValues } from "./inputValues";
import { Chip } from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import { Search } from "@material-ui/icons";
import { SearchRounded } from "@mui/icons-material";

export const LogsReportPage = () => {
  const dispatch = useDispatch();
  const { setSnackbar, clearSnackbar, clearSearch } = useSearch();

  const {
    inputValues,
    handleInputOnChange,
    handleNewValues,
    runValidates,
    fieldErrors,
  } = useForm(initialValues, fieldValidations);
  const { startDate, endDate, companies, stations, unitType } = inputValues;
  const { token } = useSelector((state) => state.login);
  const { color, message, isOpen, isLoading } = useSelector(
    (state) => state.search
  );
  const { companiesList } = useSelector((state) => state.companies);
  const [stationsOptions, setStationsOptions] = useState([]);
  const [stationsSelected, setStationsSelected] = useState([])

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (runValidates()) return;
      if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
      dispatch(
        downloadReport(
          startDate,
          endDate,
          stationsSelected.map((v) => v.value),
          unitType,
          token
        )
      );
    },
    [endDate, startDate, companies, unitType, setSnackbar, token, dispatch]
  );

  const handleCompanieChange = (v, r) => {
    let ids = []
    let nIds = []
    if(stationsSelected.length > 0) {
      ids = stationsSelected.map(a => a.value)
      v.stations.map(a => { if(!ids.includes(a.id)){nIds.push(a)} })
      if(nIds.length === 0) {
        setStationsSelected(stationsSelected) 
        setStationsOptions([])
        return
      } 
    }
    setStationsOptions([{value: 'all', label: 'Seleccionar todo'}, ...v.stations])
  };

  const handleStationChange = (v, v2) => {
    
    const isAll = v.find((val) => val.value === "all");
    if (!isAll) {
      const mixArr = [...stationsSelected, ...v].filter(a => a.value !== 'all')
      const newStations = [...new Set(mixArr)]
      handleNewValues({
        ...inputValues,
        stations: newStations,
      });
      setStationsSelected(v)
    } else {
      const filter = stationsOptions.filter(a => a.value !== 'all'  )
      const mix = [...stationsSelected, ...filter]
      const newArr = [...new Set(mix)]
      handleNewValues({
        ...inputValues,
        stations: newArr,
      });
      const clean = (prev)  => [...prev, ...newArr].flat()
      const newCleanSet = [...new Set(clean(stationsSelected))]
      setStationsSelected(newCleanSet)
    }
  }

  const handleUnitTypeOnChange = (v) => {
    handleNewValues({
      ...inputValues,
      unitType: v?.value ? v.value : "",
    });
  };

  useEffect(() => {
    clearSearch();
  }, [clearSearch]);
  
  return (
    <>
      <GlobalBox icon={<Search />} title={"Buscar reportes de logins"}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Desde"
              type="date"
              defaultValue={new Date()}
              name="startDate"
              value={startDate}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              fullWidth
              required={true}
              error={fieldErrors.startDate}
              helperText={fieldErrors.startDate || ""}
              onChange={handleInputOnChange}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Hasta"
              type="date"
              defaultValue={new Date()}
              name="endDate"
              value={endDate}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              fullWidth
              required={true}
              error={fieldErrors.endDate}
              helperText={fieldErrors.endDate || ""}
              onChange={handleInputOnChange}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={3} className={animations.fadeIn}>
            <Autocomplete
              limitTags={1}
              options={companiesList}
              filterSelectedOptions
              getOptionLabel={(option) =>
                option.label ? option.label : option.name
              }
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option?.name ? option.name : option.label}
                    {...getTagProps({ index })}
                    style={{
                      borderRadius: 4,
                    }}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  value={companies}
                  label="Compañia"
                  variant="outlined"
                />
              )}
              fullWidth
              name="companie"
              onChange={(e, v, r) => handleCompanieChange(v, r)}
              noOptionsText="No se encuentran la Compañia"
              closeIcon={
                <CloseIcon
                  fontSize="small"
                  style={{
                    marginRight: 24,
                  }}
                />
              }
              // multiple
            />
          </Grid>
          <Grid item xs={12} sm={6} className={animations.fadeIn}>
            <Autocomplete
              limitTags={1}
              options={stationsOptions}
              value={stationsSelected}
              filterSelectedOptions
              getOptionLabel={(option) =>
                option.label ? option.label : option.name
              }
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option?.name ? option.name : option.label}
                    {...getTagProps({ index })}
                    style={{
                      borderRadius: 4,
                    }}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  value={stations}
                  required={true}
                  error={fieldErrors.stations}
                  helperText={fieldErrors.stations || ""}
                  label="Plantas"
                  variant="outlined"
                />
              )}
              fullWidth
              name="stations"
              onChange={(e, v, r) => handleStationChange(v, r)}
              noOptionsText="No se encuentran estaciones"
              // renderOption={(option, { selected }) => { 
              //   debugger
              //   return(
              //   <React.Fragment>
              //     <Checkbox
              //       icon={icon}
              //       checkedIcon={checkedIcon}
              //       style={{ marginRight: 8 }}
              //       checked={selected}
              //       color="primary"
              //     />
              //     {option.label}
              //   </React.Fragment>
              // )}}
              closeIcon={
                <CloseIcon
                  fontSize="small"
                  style={{
                    marginRight: 24,
                  }}
                />
              }
              multiple
            />
          </Grid>
          <Grid item xs={12} sm={2} className={animations.fadeIn}>
            <Autocomplete
              options={unitTypeSelect}
              getOptionLabel={(option) =>
                option.label ? option.label : option.name
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  value={unitType}
                  required={true}
                  error={fieldErrors.unitType}
                  helperText={fieldErrors.unitType || ""}
                  label="Tipo de unidad"
                  variant="outlined"
                />
              )}
              fullWidth
              onChange={(e, v) => handleUnitTypeOnChange(v)}
              noOptionsText="No se encuentran tipos de unidad"
              closeIcon={
                <CloseIcon
                  fontSize="small"
                  style={{
                    marginRight: 24,
                  }}
                />
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={1}
            className={animations.fadeIn}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <RegularButton justIcon round color="info" onClick={handleSubmit} disabled={isLoading}>
              <SearchRounded />
            </RegularButton>
          </Grid>
        </Grid>
      </GlobalBox>
      {isLoading && <LoadingComponent label="Generando XLSX" />}
      <Snackbars
        place="tr"
        color={color}
        message={message}
        open={isOpen}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
};
